import { Box, Flex } from "@chakra-ui/react";
import SingleLineText from '@components/UI/SingleLineText';
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@msr/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import ContentArea from '@Layout/ContentArea';
import { useMediaQuery } from 'react-responsive';


let NighWithDivine = ({ section }) => {
    let { sectionContent } = section
    const isMobile = useMediaQuery({ maxWidth: 480 });

    return <Box py={{ base: '3rem', md: '3rem' }}
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        backgroundImage={{
            md: sectionContent?.[0].image?.url,
            base: ''
        }}
    >
        <SingleLineText sectionContent={sectionContent?.[1]} my={"0px"} textAlign={'center'} fontFamily={'FedraSerifAStdBook'} fontSize={{ base: '38px', md: '54px' }} color={"#FFA735"} fontWeight={600} />
        <SingleLineText sectionContent={sectionContent?.[2]} my={-2} textAlign={'center'} fontFamily={'FedraSansStd-medium'} fontSize={{ base: '24px', md: '26px' }} color={"#FFA735"} fontWeight={500} />
        <SingleLineText sectionContent={sectionContent?.[3]} textAlign={'center'} my={6} mx={'auto'} fontFamily={'FedraSansStd-book'} fontSize={'16px'} color={"#FFF"} fontWeight={400} w={{ base: '269px', md: '470px' }} />
        <SingleLineText sectionContent={sectionContent?.[4]} my={-2} textAlign={'center'} fontFamily={'FedraSerifAStdBook'} fontSize={{ base: '18px', md: '26px' }} color={"#FFA735"} fontWeight={600} />
        <SingleLineText sectionContent={sectionContent?.[5]} my={2} textAlign={'center'} fontFamily={'FedraSerifAStdBook'} fontSize={{ base: '16px', md: '20px' }} color={"#fff"} fontWeight={350} />
        <Box py={"25px"}>
            <SingleImage
                sectionContent={sectionContent?.[6]}
                my={'0px'} mx={'0px'} px={'0px'}
            />
        </Box>
        <SingleLineText sectionContent={sectionContent?.[7]} my={{ base: '0px', md: -1 }} mb={{ base: 6, md: 7 }} textAlign={'center'} fontFamily={'FedraSerifAStdBook'} fontSize={{ base: '20px', md: '26px' }} color={"#FFA735"} fontWeight={600} />
        {/* <SingleLineText sectionContent={sectionContent?.[8]} w={{ base: '288px', md: 'auto' }} textAlign={'center'} my={3} mx={'auto'} fontFamily={'FedraSansStd-book-i'} fontSize={'16px'} color={"#FFF"} fontWeight={500} />
        <SingleLineText sectionContent={sectionContent?.[9]} w={{ base: '288px', md: 'auto' }} textAlign={'center'} my={3} mx={'auto'} fontFamily={'FedraSansStd-book-i'} fontSize={'16px'} color={"#FFF"} fontWeight={500} />
        <SingleLineText sectionContent={sectionContent?.[10]} w={{ base: '288px', md: 'auto' }} textAlign={'center'} my={3} mx={'auto'} fontFamily={'FedraSansStd-book-i'} fontSize={'16px'} color={"#FFF"} fontWeight={500} /> */}
        <Box id={'nightWithDivineDiv'}>
            <ContentArea
                mainContent={isMobile ? sectionContent?.[11]?.body : sectionContent?.[8]?.body}
                sectionContent={isMobile ? sectionContent?.[11] : sectionContent?.[8]}
                width={{ base: '288px', md: 'auto' }}
                tAlign={'center'} mt={'-5px'} pb={"0px"} mx={'auto'}
                fontFamily={'FedraSansStd-book-i'} font={'16px'} color={"#FFF"} fontWeight={500}
            />
            <ContentArea
                mainContent={isMobile ? sectionContent?.[12]?.body : sectionContent?.[9]?.body}
                sectionContent={isMobile ? sectionContent?.[12] : sectionContent?.[9]}
                width={{ base: '288px', md: 'auto' }}
                tAlign={'center'} mt={'10px'} pb={'0px'} mx={'auto'}
                fontFamily={'FedraSansStd-book-i'} font={'16px'} color={"#FFF"} fontWeight={500}
            />
            <ContentArea
                mainContent={isMobile ? sectionContent?.[13]?.body : sectionContent?.[10]?.body}
                sectionContent={isMobile ? sectionContent?.[13] : sectionContent?.[10]}
                width={{ base: '288px', md: 'auto' }}
                tAlign={'center'} mt={'10px'} pb={'0px'} mx={'auto'}
                fontFamily={'FedraSansStd-book-i'} font={'16px'} color={"#FFF"} fontWeight={500}
            />
        </Box>
        <style>
            {`#nightWithDivineDiv strong {font-family: FedraSansStd-book !important;}`}
        </style>
    </Box>
}

export default NighWithDivine

